module.exports = __webpack_public_path__ + "static/img/news2.5aea7db3.png";